<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h360_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="价格区间名称"
                  prop="name"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.name"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="最小价格"
                  prop="minPrice"
                >
                  <el-input-number
                    v-model="dialogAddEditViewForm.minPrice"
                    :min="0"
                    :precision="2"
                    :disabled="eventType==='view'"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="最大价格"
                  prop="maxPrice"
                >
                  <el-input-number
                    v-model="dialogAddEditViewForm.maxPrice"
                    :min="dialogAddEditViewForm.minPrice"
                    :precision="2"
                    :disabled="eventType==='view'"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="状态"
                  prop="status"
                >
                  <el-radio-group v-model="dialogAddEditViewForm.status">
                    <el-radio
                      :label="1"
                      :disabled="eventType==='view'"
                    >
                      启用
                    </el-radio>
                    <el-radio
                      :label="2"
                      :disabled="eventType==='view'"
                    >
                      停用
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    placeholder="备注"
                    style="margin-top:10px;"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// API
import { viewPriceRangeSettingApi, savePriceRangeSettingApi } from '@/api/v2/priceRangeSetting'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        name: [
          { required: true, message: '请输入价格区间名称', trigger: 'blur' },
          { max: 32, message: '价格区间名称最多输入32个字符', trigger: 'blur' }
        ],
        minPrice: [{ required: true, message: '请输入价格区间最小价格', trigger: 'blur' }],
        maxPrice: [{ required: true, message: '请输入价格区间最大价格', trigger: 'blur' }],
        status: [{ required: true, message: '请选择价格区间设置状态', trigger: 'change' }],
        remark: [{ max: 500, message: '备注内容最多输入500个字符', trigger: 'blur' }]
      },
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.dialogAddEditViewForm = {
          name: '',
          minPrice: 0,
          maxPrice: 0,
          status: 1,
          remark: ''
        }

        if (_this.eventType !== 'add') {
          _this.loadPriceRangeData()
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadPriceRangeData () {
      let _this = this;
      viewPriceRangeSettingApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        for (let key in _this.dialogAddEditViewForm) {
          _this.dialogAddEditViewForm[key] = data[key]
        }
        _this.dialogAddEditViewForm.id = data.id
      })
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false)
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      let _this = this;
      _this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          _this.$confirm((_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '产品价格区间设置', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true })
            .then(async () => {
              savePriceRangeSettingApi(_this.dialogAddEditViewForm).then(() => {
                _this.$message({ message: '保存成功', type: 'success' })
                _this.reloadData()
                _this.modalClose()
              }).catch(() => { })
            }).catch(() => { })
        }
      })
    },
  }
}
</script>
<style lang="scss"  scoped>
</style>
